<!--
  ~ Copyright (c) 2019. Sonrai Analytics Ltd.
  ~ Developed by Deva Sen. & Warren Dowey
  -->

<div [class]="'app-container app-theme-white'">
  <app-sidebar></app-sidebar>
  <div class="app-main__outer">
    <div class="app-main__inner p-0">
      <div [@architectUIAnimation]="o.isActivated ? o.activatedRoute : ''"></div>
      <div>
        <router-outlet #o="outlet"></router-outlet>
      </div>
    </div>
  </div>
  <!--<app-options-drawer></app-options-drawer>-->
</div>
